import { render, staticRenderFns } from "./SidebarStructureStep.vue?vue&type=template&id=a8d073dc"
import script from "./SidebarStructureStep.vue?vue&type=script&lang=js"
export * from "./SidebarStructureStep.vue?vue&type=script&lang=js"
import style0 from "./SidebarStructureStep.vue?vue&type=style&index=0&id=a8d073dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports